<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <div class="pt-40 clear"></div>
        <div class="thank-you-icon"></div>
        
        <div class="container m-auto" style="font-size: 18px; max-width: 500px;">
          <p>
            We're honoured that your've chosen My Pay Stat, powered by Capital & Centric Funding Pty Ltd
          </p>
          <p>
            You will receive updates regarding your application via email and SMS.
          </p>
          <p>
            If you haven't already had an answer from our super intelligent software then rest assured we are working to ensure you revice a apeedy answer.
          </p>
          <p>
            While you're wating for the result of your application.<br>
            please <a>log into</a> your dashboard to see:<br>
            Live Status Updates<br>
            Articles<br>
            Important Documents<br>
            &<br>
            other tools and featrues.
          </p>
        </div>

      </div>
    </div>
    
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
